// Base radius lives in the MUI `shape`. The named `radii` below map onto the
// design-system corner-radius scale, all in PIXELS.
//
// Figma DS (VisionHeight MUI, collection `shape`) has exactly FOUR radius
// tokens: borderRadius-4 / -8 / -12 / -100. That's the whole scale — there is
// no 10 and no 16. `card` is an app-level composition (the prompt card) with no
// dedicated DS component, so per "Figma wins" it's snapped to the nearest DS
// step (16→12); the icon rail's rows land on `control` for the same reason.
//
// A NOTE ON `sm`, because it used to be called `input` and that name was wrong:
// nothing in the DS draws a text field or a button on the 4px step. Verified on
// the canonical DS symbols — <TextField> (79942:41405) and <Button>
// (80696:118540) are both `borderRadius-8`. The 4px step is for chips
// (<Chip> 80437:141187), code blocks, badges and inline images. The old name
// sent three screens off patching `MuiOutlinedInput` back to 8 by hand.
//
// IMPORTANT — apply them consistently:
//   • in component `styleOverrides` (theme), use the raw value:  borderRadius: radii.control
//   • in a component's `sx`, use a px STRING:                    borderRadius: `${radii.control}px`
// (MUI's `sx` multiplies a bare numeric `borderRadius` by shape.borderRadius=8,
//  so passing the raw token there would over-round — always use the px string.)
export const shape = { borderRadius: 8 } as const; // DS borderRadius-8 (base)

export const radii = {
  sm: 4, // DS borderRadius-4 — chips, code blocks, badges, inline images. NOT inputs.
  // DS borderRadius-8 — every control: text fields, selects, buttons, sidebar
  // and icon-rail rows. Called `nav` until the audit, which was the same trap as
  // `input: 4` one step along: nobody looking for a BUTTON's radius goes looking
  // under "nav", so they type a number instead and the drift starts again.
  control: 8,
  card: 12, // the prompt card, dialogs, page papers — DS borderRadius-12 (snapped 16→12)
  pill: 999, // fully rounded — DS borderRadius-100 ("full"); 999 keeps tall elements round
} as const;
